import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {tap} from 'rxjs';
import {environment} from 'src/environments/environment';
import {ConnectionStore} from './connection.store';

/**
 * Tells the connection store whether the engine answers (KAB-2441): a request without an answer (status 0: no network,
 * engine down, or a response the browser hid for lack of CORS headers) makes it probe the engine; any answer, an
 * error included, says it is reachable. Registered last, it sees each request sent, the replays included.
 */
export const connectionInterceptor: HttpInterceptorFn = (req, next) => {
	if (!req.url.startsWith(environment.engineURL)) {
		return next(req);
	}
	const connection = inject(ConnectionStore);
	return next(req).pipe(
		tap({
			next: event => {
				if (event instanceof HttpResponse) {
					connection.answered();
				}
			},
			error: (error: unknown) => {
				if (error instanceof HttpErrorResponse && error.status === 0) {
					connection.noAnswer();
				} else {
					connection.answered();
				}
			},
		}),
	);
};
